var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_4272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9997 0H11.0002C4.95091 0 0.000488281 4.95042 0.000488281 10.9997V33.0003C0.000488281 39.048 4.95091 44 11.0002 44H32.9997C39.049 44 43.9994 39.048 43.9994 33.0003V10.9997C43.9994 4.95042 39.049 0 32.9997 0ZM40.3327 33.0003C40.3327 37.0427 37.0443 40.3332 32.9997 40.3332H11.0002C6.95728 40.3332 3.66724 37.0427 3.66724 33.0003V10.9997C3.66724 6.95626 6.95728 3.66676 11.0002 3.66676H32.9997C37.0443 3.66676 40.3327 6.95626 40.3327 10.9997V33.0003Z",
    fill: "#012913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9184 12.8329C35.4371 12.8329 36.6683 11.6017 36.6683 10.0829C36.6683 8.56419 35.4371 7.33301 33.9184 7.33301C32.3996 7.33301 31.1685 8.56419 31.1685 10.0829C31.1685 11.6017 32.3996 12.8329 33.9184 12.8329Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 10.9998C15.9239 10.9998 11.0005 15.9237 11.0005 21.9995C11.0005 28.073 15.9239 33.0003 22.0002 33.0003C28.0748 33.0003 33 28.073 33 21.9995C33 15.9237 28.0748 10.9998 22.0002 10.9998ZM22.0002 29.3335C17.9506 29.3335 14.6672 26.0502 14.6672 21.9995C14.6672 17.9488 17.9506 14.6665 22.0002 14.6665C26.0498 14.6665 29.3332 17.9488 29.3332 21.9995C29.3332 26.0502 26.0498 29.3335 22.0002 29.3335Z",
    fill: "#012913"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_4272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram-icon.ee405617c6614f80c25240a428145c78.svg";
export { ForwardRef as ReactComponent };